import React from 'react';
import { Box, Typography } from '@mui/material';
import { Flag as FlagIcon } from '@mui/icons-material';
import UserReportsSection from './UserReportsSection';

const FlaggedReports: React.FC = () => {
  return (
    <Box>
      <Box display="flex" alignItems="center" gap={1} mb={1}>
        <FlagIcon color="error" />
        <Typography variant="h5">Flagged Reports</Typography>
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Content flagged by end users via the in-app Report button. Each report
        is part of our human-oversight moderation workflow — review the report
        details, take action against the offender if appropriate, and record
        moderation notes for the audit trail.
      </Typography>

      <UserReportsSection />
    </Box>
  );
};

export default FlaggedReports;
